import { useState, useEffect } from "react";
import { Outlet, useParams } from "react-router-dom";
import styles from "./reportsEntryPoint.module.scss";
import { ReportsProps } from "../../../interfaces/pages";
import PageCard from "../../../components/PageCard";
import ButtonShared from "../../../components/Button/Button";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { TextField, Select, MenuItem, FormControl, InputLabel, CircularProgress } from "@mui/material";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import moment, { Moment } from "moment";

const ReportsEntryPoint = ({
    getGeneralReport,
    getDealershipReport,
    getDealerships,
    dealerships,
    fetchingReports,
    generalReport,
    dealershipReport
}: ReportsProps) => {
    const params = useParams();
    const [startDateGeneral, setStartDateGeneral] = useState<Moment | null>(moment().subtract(30, 'days'));
    const [endDateGeneral, setEndDateGeneral] = useState<Moment | null>(moment());
    const [startDate, setStartDate] = useState<Moment | null>(moment().subtract(30, 'days'));
    const [endDate, setEndDate] = useState<Moment | null>(moment());
    const [dealershipId, setDealershipId] = useState<string>("");
    const [selectedSource, setSelectedSource] = useState<string>("chileAutos");

    useEffect(() => {
        getDealerships(1, 1000, "all");
    }, [getDealerships]);

    const handleGeneralReport = () => {
        if (startDateGeneral && endDateGeneral) {
            getGeneralReport(
                startDateGeneral.format('YYYY-MM-DD'),
                endDateGeneral.format('YYYY-MM-DD')
            );
        }
    };

    const handleDealershipReport = () => {
        if (startDate && endDate && dealershipId) {
            getDealershipReport(
                dealershipId,
                startDate.format('YYYY-MM-DD'),
                endDate.format('YYYY-MM-DD'),
                selectedSource === 'Todos' ? '' : selectedSource
            );
        }
    };

    return (
        params.id ? <Outlet /> :
            <LocalizationProvider dateAdapter={AdapterMoment}>
                <PageCard className={styles.reportsContainer}>
                    <div className={styles.header}>
                        <h2 className={styles.title}>Reportes de Leads</h2>
                        <p className={styles.subtitle}>Genera reportes detallados de leads por fecha o concesionaria</p>
                    </div>

                    <div className={styles.reportCard}>
                        <h3 className={styles.cardTitle}>Reporte General</h3>
                        <p className={styles.cardDescription}>
                            Obtén un reporte completo con todas las concesionarias para un período de tiempo
                        </p>

                        <div className={styles.dateRange}>
                            <DatePicker
                                label="Fecha inicio"
                                value={startDateGeneral}
                                onChange={(newValue) => setStartDateGeneral(newValue)}
                                renderInput={(params) => <TextField {...params} />}
                                maxDate={moment()}
                                inputFormat="DD/MM/YYYY"
                            />
                            <DatePicker
                                label="Fecha fin"
                                value={endDateGeneral}
                                onChange={(newValue) => setEndDateGeneral(newValue)}
                                renderInput={(params) => <TextField {...params} />}
                                maxDate={moment()}
                                minDate={startDateGeneral}
                                inputFormat="DD/MM/YYYY"
                            />
                            <ButtonShared
                                className={styles.generateButton}
                                title={fetchingReports === "general" ? "Descargando..." : "Descargar Reporte"}
                                onPress={handleGeneralReport}
                                disabled={!startDateGeneral || !endDateGeneral || fetchingReports === "general"}
                                icon={fetchingReports === "general" ? <CircularProgress size={16} color="inherit" /> : <CloudDownloadIcon />}
                                primary={true}
                                fontSize="small"
                            />
                        </div>


                    </div>

                    {/* {generalReport && (
                        <div className={styles.successCard}>
                            <h4 className={styles.successTitle}>Reporte general generado exitosamente</h4>
                        </div>
                    )} */}

                    <div className={styles.reportCard}>
                        <h3 className={styles.cardTitle}>Reporte por Concesionaria</h3>
                        <p className={styles.cardDescription}>
                            Obtén un reporte específico de una concesionaria en un período de tiempo determinado
                        </p>

                        <div className={styles.formRow}>
                            <div className={styles.formGroup}>
                                <FormControl fullWidth>
                                    <InputLabel sx={{ '&.Mui-focused': { color: '#1A1C21' } }}>Concesionaria</InputLabel>
                                    <Select
                                        value={dealershipId}
                                        label="Concesionaria"
                                        onChange={(e) => setDealershipId(e.target.value)}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 200,
                                                    width: 250,
                                                },
                                            },
                                        }}
                                        sx={{
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                borderColor: 'rgba(0, 0, 0, 0.23)',
                                            },
                                            '&:hover .MuiOutlinedInput-notchedOutline': {
                                                borderColor: '#1A1C21',
                                            },
                                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                borderColor: '#1A1C21',
                                            },
                                        }}
                                    >
                                        {dealerships?.list?.data?.map((dealership: any) => (
                                            <MenuItem key={dealership._id} value={dealership._id}>
                                                {dealership.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>

                            <div className={styles.formGroup}>
                                <FormControl fullWidth>
                                    <InputLabel sx={{ '&.Mui-focused': { color: '#1A1C21' } }}>Fuente de leads</InputLabel>
                                    <Select
                                        value={selectedSource}
                                        label="Fuente de leads"
                                        onChange={(e) => setSelectedSource(e.target.value)}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 200,
                                                    width: 250,
                                                },
                                            },
                                        }}
                                        sx={{
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                borderColor: 'rgba(0, 0, 0, 0.23)',
                                            },
                                            '&:hover .MuiOutlinedInput-notchedOutline': {
                                                borderColor: '#1A1C21',
                                            },
                                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                borderColor: '#1A1C21',
                                            },
                                        }}
                                    >
                                        <MenuItem value="Linze">Linze</MenuItem>
                                        <MenuItem value="ChileAutos">ChileAutos</MenuItem>
                                        <MenuItem value="Meli">Mercado Libre</MenuItem>
                                        <MenuItem value="Todos">Todos</MenuItem>
                                    </Select>
                                </FormControl>
                            </div>
                        </div>

                        <div className={styles.dateRange}>
                            <DatePicker
                                label="Fecha inicio"
                                value={startDate}
                                onChange={(newValue) => setStartDate(newValue)}
                                renderInput={(params) => <TextField {...params} />}
                                maxDate={moment()}
                                inputFormat="DD/MM/YYYY"
                            />
                            <DatePicker
                                label="Fecha fin"
                                value={endDate}
                                onChange={(newValue) => setEndDate(newValue)}
                                renderInput={(params) => <TextField {...params} />}
                                maxDate={moment()}
                                minDate={startDate}
                                inputFormat="DD/MM/YYYY"
                            />
                            <ButtonShared
                                className={styles.generateButton}
                                title={fetchingReports === "dealership" ? "Descargando..." : "Descargar Reporte"}
                                onPress={handleDealershipReport}
                                disabled={!dealershipId || !startDate || !endDate || fetchingReports === "dealership"}
                                icon={fetchingReports === "dealership" ? <CircularProgress size={16} color="inherit" /> : <CloudDownloadIcon />}
                                primary={true}
                                fontSize="small"
                            />
                        </div>
                    </div>

                    {/* {dealershipReport && (
                        <div className={styles.successCard}>
                            <h4 className={styles.successTitle}>Reporte de concesionaria generado exitosamente</h4>
                        </div>
                    )} */}

                </PageCard>
            </LocalizationProvider>
    );
};

export default ReportsEntryPoint;
